export enum IconButtonEnum {
  FILTER = 'filter',
  CLOSE_MENU = 'close_menu',
  EXPAND_MENU = 'expand_menu',
  OPEN = 'open',
  COLUMNS_SETTINGS = 'columns_settings',
  LINK = 'link',
  UNLINK = 'unlink',
  SHOW = 'show',
  HIDE = 'hide',
  SHOW_ITEM = 'show_item',
  HIDE_ITEM = 'hide_item',
  IMPORT_ATTACHMENTS = 'import_attachments',
  DOWNLOAD_ATTACHMENTS = 'download_attachments',
  IMAGE = 'image',
  PDF = 'pdf',
  DOWNLOAD_ATTACHMENT = 'download_attachment',
  DELETE = 'delete',
  REMOVE = 'remove',
  PRODUCT_INFORMATION = 'product_information',
  EDIT = 'edit',
  CREATE_INVOICE = 'create_invoice',
  RECORD_INVOICE = 'record_invoice',
  CHANGE_AMOUNT = 'change_amount',
  APPLY = 'apply',
  SORT = 'sort',
  ADD = 'add',
}

// Default tooltip (translation key) of an icon-only button
export const ICON_BUTTON_TOOLTIPS: { [key in IconButtonEnum]: string } = {
  [IconButtonEnum.FILTER]: 'ICON_BUTTON_TOOLTIP.FILTER',
  [IconButtonEnum.CLOSE_MENU]: 'ICON_BUTTON_TOOLTIP.CLOSE_MENU',
  [IconButtonEnum.EXPAND_MENU]: 'ICON_BUTTON_TOOLTIP.EXPAND_MENU',
  [IconButtonEnum.OPEN]: 'ICON_BUTTON_TOOLTIP.OPEN',
  [IconButtonEnum.COLUMNS_SETTINGS]: 'ICON_BUTTON_TOOLTIP.COLUMNS_SETTINGS',
  [IconButtonEnum.LINK]: 'ICON_BUTTON_TOOLTIP.LINK',
  [IconButtonEnum.UNLINK]: 'ICON_BUTTON_TOOLTIP.UNLINK',
  [IconButtonEnum.SHOW]: 'ICON_BUTTON_TOOLTIP.SHOW',
  [IconButtonEnum.HIDE]: 'ICON_BUTTON_TOOLTIP.HIDE',
  [IconButtonEnum.SHOW_ITEM]: 'ICON_BUTTON_TOOLTIP.SHOW_ITEM',
  [IconButtonEnum.HIDE_ITEM]: 'ICON_BUTTON_TOOLTIP.HIDE_ITEM',
  [IconButtonEnum.IMPORT_ATTACHMENTS]: 'ICON_BUTTON_TOOLTIP.IMPORT',
  [IconButtonEnum.DOWNLOAD_ATTACHMENTS]: 'ICON_BUTTON_TOOLTIP.DOWNLOAD',
  [IconButtonEnum.IMAGE]: 'ICON_BUTTON_TOOLTIP.IMAGE',
  [IconButtonEnum.PDF]: 'ICON_BUTTON_TOOLTIP.PDF',
  [IconButtonEnum.DOWNLOAD_ATTACHMENT]: 'ICON_BUTTON_TOOLTIP.DOWNLOAD_ATTACHMENT',
  [IconButtonEnum.DELETE]: 'ICON_BUTTON_TOOLTIP.DELETE',
  [IconButtonEnum.REMOVE]: 'ICON_BUTTON_TOOLTIP.REMOVE',
  [IconButtonEnum.PRODUCT_INFORMATION]: 'ICON_BUTTON_TOOLTIP.PRODUCT_INFORMATION',
  [IconButtonEnum.EDIT]: 'ICON_BUTTON_TOOLTIP.EDIT',
  [IconButtonEnum.CREATE_INVOICE]: 'ICON_BUTTON_TOOLTIP.CREATE_INVOICE',
  [IconButtonEnum.RECORD_INVOICE]: 'ICON_BUTTON_TOOLTIP.RECORD_INVOICE',
  [IconButtonEnum.CHANGE_AMOUNT]: 'ICON_BUTTON_TOOLTIP.CHANGE_AMOUNT',
  [IconButtonEnum.APPLY]: 'ICON_BUTTON_TOOLTIP.APPLY',
  [IconButtonEnum.SORT]: 'ICON_BUTTON_TOOLTIP.SORT',
  [IconButtonEnum.ADD]: 'ICON_BUTTON_TOOLTIP.ADD',
};
